export default __webpack_public_path__ + "static/media/news63.57e68696.jpg";